import React, { useState, useEffect } from 'react';
import './Dashboard.scss';
import Sidebar from './Sidebar';
import MainContent from './MainContent';
import { APIS } from '../../../../utils/api-factory';
import './Dashboard.scss'

export default function Main({admin,allStatus,pageViewHandler}) {
    const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 1800 ? true : false);
    const [activeTab, setActiveTab] = useState("overview")
    const [activeSubTab, setActiveSubTab] = useState("")
    const [status,setStatus] =useState([])

    const handleTabType = (value, type) => {
        if (type == "activeTab") {
            setActiveTab(value?.ShowType)
            setActiveSubTab(value?.subType?.[0]?.ShowType)
        } else if (type == "activeSubTab") {
            setActiveSubTab(value)
        }
    }

    const handleBack=(e)=>{
        pageViewHandler(e,"landingPage")
    }

    useEffect(() => {
        handleStatus()
    }, [])


    const handleStatus = () => {
        fetch(APIS.GET_ALL_STATUS)
            .then(res => res.json())
            .then(json => {
                if (json.responseCode == 0) {
                } else {
                    setStatus(json)
                }
            })
    }

    return (
        <div className="Main-dashboard">
            <div className={`dashboard-sidebar ${isSidebarOpen ? "open" : ""}`}
                onMouseEnter={() => {window.innerWidth > 1800 ? null : setIsSidebarOpen(true)}}
                onMouseLeave={() => {window.innerWidth > 1800 ? null : setIsSidebarOpen(false)}}
            >
                <Sidebar
                    handleTabType={handleTabType}
                    isSidebarOpen={isSidebarOpen}
                    activeSubTab={activeSubTab}
                    activeTab={activeTab}
                />
            </div>

            <div className={`dashboard-main-content ${isSidebarOpen ? "open" : ""}`} style={{ padding: window.innerWidth > 1800 ? "20px 40px" : "20px",overflow:'auto' }}>
                <MainContent
                    activeSubTab={activeSubTab}
                    activeTab={activeTab}
                    status={status}
                    admin={admin} allStatus={allStatus}
                    handleBack={handleBack}
                />
            </div>
        </div>
    );
}
